import React from "react";
import Labels from "../../variables/labels";
import Button from '../button/button.jsx';
import StarRatings from 'react-star-ratings';
import Emitter from "../../core/services.js";

class FeedbackBoxCard extends React.Component {
  constructor(props) {
    super(props);
    this.refInput = React.createRef();
    this.shinningTimeout = null;
    const { data: { valueRating, observation, id }, type } = this.props;
    this.state = {
      observation,
      valueRating,
      id,
      dimension: type,
      isSmall: type === 'small',
      isMedium: type === 'medium',
      isShinning: false,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    Emitter.on('RATING_SHINNING', this.handleRatingShinning);
  }

  componentWillUnmount() {
    if (this.shinningTimeout) {
      clearTimeout(this.shinningTimeout);
    }
    Emitter.off('RATING_SHINNING', this.handleRatingShinning);
  }

  handleRatingShinning = () => {
    if (this.shinningTimeout) {
      clearTimeout(this.shinningTimeout);
    }

    this.setState({ isShinning: true });
    this.shinningTimeout = setTimeout(() => {
      this.setState({ isShinning: false });
      this.shinningTimeout = null;
    }, 1700);
  }

  handleObsChange = (event) => {
    const observation = event.target.value;
    this.setState({ observation });
    const feedback = {
      classification: this.state.valueRating,
      observation,
    }
    this.props.callback(feedback);
  }


  handleRatingValue = (value) => {
    const observation = this.refInput.current ? this.refInput.current.value : this.state.observation;
    this.setState({ valueRating: value, observation });
    const feedback = {
      classification: value,
      observation,
    }
    this.props.callback(feedback);
  }

  validateSubmition = () => {
    if (this.state.isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    const feedback = {
      classification: this.state.valueRating,
      observation: this.state.observation, 
    }
    const result = this.props.callback(feedback, true);
    // Reset the loading state once the submission finishes (success or error)
    if (result && typeof result.then === 'function') {
      result
        .catch(() => {})
        .finally(() => this.setState({ isSubmitting: false }));
    }
  }

  renderRatingContainer = (rating) => {
    const {isSmall, isMedium, isShinning} = this.state;
    const starDimension = isSmall ? '18px' : isMedium ? '27px' : '40px';
    return(
      <div className={`rating-container ${isMedium ? 'mt-1' : 'mt-0'} ${isShinning ? 'shinning' : ''}`}>
        <div className="rate-service">
          <StarRatings
            rating={rating || 0}
            numberOfStars={5}
            name={`rating-${rating || 0}`}
            starRatedColor="#0196E0"
            starEmptyColor="rgba(1, 150, 224, 0.15)"
            starHoverColor="#0196E0"
            starDimension={starDimension}
            starSpacing="12px"
            svgIconViewBox="0 0 16 16"
            svgIconPath="m8 12-4.114 2.163.785-4.581-3.328-3.245 4.6-.669L8 1.5l2.057 4.168 4.6.669-3.328 3.245.785 4.581z"
            changeRating={this.handleRatingValue}
          />
        </div>
      </div>
    );
  }

  renderSmallButton = (isSmall) => {
    if (!isSmall) {
      return <></>;
    }

    const { isSubmitting } = this.state;

    return (
      <div className="ms-2">
        <Button
          className="cta-button-secondary white d-medium"
          type="button"
          value={isSubmitting ? "A enviar" : "Enviar"}
          disabled={isSubmitting}
          onClick={() => this.validateSubmition()}
        />
      </div>
    );
  }

  render() {
    const { feedback, valueRating, observation, id, isSmall, dimension } = this.state;
    const rows = isSmall ? 1 : 4;
    const renderFeedbackTitle = () => {
      const titleText = () =>{
        if (feedback) { 
          return <span> { Labels.feedbackTitle } </span>
        } else {
          return <span> {Labels.feedbackMessage } </span>
        }
      }
      return null;
    }
   
    return (
      <div className={`card-service-feedback-container ${!isSmall ? 'no-card w-100' : ''}`}>
        {this.renderRatingContainer(valueRating, id)}
        { renderFeedbackTitle(feedback) }
        <div className={`text-area-container ${isSmall ? 'pt-2' : 'mt-3'}`}>
          <textarea ref={this.refInput} defaultValue={observation} maxLength="2000" onChange={this.handleObsChange}
            rows={rows} className={`text-area-feedback ${dimension}`} placeholder='Observações' />
          {this.renderSmallButton(isSmall)}
        </div>
      </div>
    );
  }
}
export default FeedbackBoxCard;